/**
 * Radice delle query key commessa, isolata da `query-keys.ts` perché quello
 * trascina `./api` (e quindi il client axios): chi deve solo invalidare non
 * può dipendere dal layer HTTP.
 */
export const COMMESSA_QUERY_ROOT = ['commessa'] as const;
